import { object, string } from 'yup'

export const ProjectsSchema = object().shape({
  name: string().trim().required('Name is required'),
  type: string().trim().required('Type is required')
})
